import { token } from '@atlaskit/tokens';
import { useLocale } from '@databases/intl';
import { type DatabaseFieldType } from '@databases/types/database';
import { toDisplayDate } from '@databases/utils/database/field-types/date';
import React, { type FunctionComponent, useMemo } from 'react';
import styled from 'styled-components';

import { type ViewComponentProps } from './types';

export const DateValueViewContainer = styled.span<{
  showDisabledValue?: boolean;
}>`
  background: ${token('color.background.neutral', '#091E420F')};
  border-radius: ${token('radius.small', '3px')};
  color: ${({ showDisabledValue }) =>
    showDisabledValue
      ? token('color.text.disabled', '#8993A4')
      : token('color.text', '#172B4D')};
  padding: ${token('space.025', '2px')} ${token('space.050', '4px')};
`;

const DateValueView: FunctionComponent<ViewComponentProps<DatabaseFieldType.DATE>> = ({
  value,
  showDisabledValue,
}) => {
  const locale = useLocale();

  const displayDate = useMemo(() => {
    if (!value) {
      return null;
    }

    let date = value;
    try {
      date = toDisplayDate(value, locale) ?? value;
      // eslint-disable-next-line canvas/no-swallow-errors-in-catch
    } catch (e) {
      /* empty */
    }

    return date;
  }, [value, locale]);

  if (!value) {
    return null;
  }

  return (
    <DateValueViewContainer showDisabledValue={showDisabledValue}>
      {displayDate}
    </DateValueViewContainer>
  );
};

export default DateValueView;
